import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/luckyDraw',
  component: LAYOUT,
  name: 'LuckyDraw',
  redirect: '/luckyDraw/index',
  meta: {
    title: '大转盘',
  },
  children: [
    {
      path: 'index',
      name: 'LuckyDrawIndex',
      meta: {
        title: '大转盘',
      },
      component: () => import('@/views/luckyDraw/index'),
    },
    {
      path: 'recordList',
      name: 'RecordList',
      meta: {
        title: '中奖记录',
      },
      component: () => import('@/views/luckyDraw/recordList'),
    },
    {
      path: 'receive',
      name: 'Receive',
      meta: {
        title: '奖品详情',
      },
      component: () => import('@/views/luckyDraw/receive'),
    },
    {
      path: 'prizeDetail',
      name: 'PrizeDetail',
      meta: {
        title: '奖品详情',
      },
      component: () => import('@/views/luckyDraw/prizeDetail'),
    },
    {
      path: 'receiveSuccess',
      name: 'ReceiveSuccess',
      meta: {
        title: '领取奖品',
      },
      component: () => import('@/views/luckyDraw/receiveSuccess'),
    },
  ],
};
